package ru.it_mozaika.sender.common.models

import kotlinx.datetime.Instant
import kotlinx.serialization.Contextual
import kotlinx.serialization.Serializable

@Serializable
data class Store(
    val id: String,
    var name: String,
    var url: String,
    var confirmationEnabled: Boolean,
    var confirmEmailTopic: String = "",
    var confirmEmailTemplate: EmailTemplate = EmailTemplate.Freemarker(),
//    var confirmationSender: String = "5e42d0f1bbbe5a012253213d",
    var confirmationPageUrl: String = "",
    var unsubscribePage: String = "",
    val unsubscribePageId: String? = "",
    val confirmationPageId: String? = "",
    val reviewTemplateId: String? = "",
    val senderId: String? = ""
)

@Serializable
data class StoreUpdateRequest(
    val name: String,
    val url: String
)

@Serializable
data class CatalogSettings(
    val yml: String,
    val syncPeriod: Long
)


@Serializable
data class CatalogSynchronizationResult(
    @Contextual val date: Instant,
    val error: String? = null
)

@Serializable
data class CatalogSynchronizationStatistics(
    var categoriesCount: Int = 0,
    var productsCount: Int = 0,
    var productsInStockCount: Int = 0
)

@Serializable
data class CatalogSynchronizationInfo(
    val synchronizationInProgress: Boolean,
    val lastResult: CatalogSynchronizationResult,
    val stats: List<CatalogSynchronizationStatistics>
)

@Serializable
data class Category(
    val id: String,
    val store: String,
    var name: String,
    var parent: String? = null
)

@Serializable
data class ProductAvailability(
    @Contextual val date: Instant,
    val available: Boolean
)

@Serializable
data class Product(
    val store: String,

    val id: String = "",
    var available: Boolean = false,
    val availabilityByDate: List<ProductAvailability> = mutableListOf(),

    var name: String = "",
    var url: String? = null,
    var picture: String = "",

    var price: Float = 0.0f,
    var oldPrice: Float? = null,

    var category: MutableList<String> = mutableListOf(),

    var description: String = "",

    var vendor: String? = null,
    var vendorCode: String? = null,

    var params: MutableMap<String, String> = mutableMapOf(),
    var prettyName: String? = ""
)